import actions from './actionTypes';
import * as api from '../services/api';
import _ from 'lodash';
import { Colors } from '../utilities';
import {
  getURLQueryStringAsDictionary,
  isWallartLiteWebLinkEdit,
  canEditProject,
  isPremiumTheme,
  isSignageSuiteProduct,
  isHostedContent,
  retailerPosCode,
  retailerEmployeeCode,
  convertFromCamelCase,
  orientationSupportedProducts,
  getProductWithName
} from '../utilities/HelperFunctions/HelperFunctions';
import {
  isOmenLaptopOfTurkeyAccount,
  isOmenLaptop,
  isBannerApp,
  isRollupApp,
  isCanvasApp
} from '../utilities/HelperFunctions/SignageHelperFunctions';
import {
  selectWall,
  changeLanguage,
  isPresetSizeAvailableInLaunch,
  isCustomSizeAvailableInProjectLaunch,
  setSelectedProduct,
  updateModelsForSelectedWallSize,
  setCanvasType
} from './homeActions';
import * as Constants from '../utilities/constants/Constants';
import * as CookieUtils from '../utilities/CookieUtils/CookieUtils';
import {
  setExternalContent,
  setWebLink,
  setAccountId,
  setExternalLink,
  setApplicationGroupId,
  changeMinimumViewingDistance,
  setCustomerName,
  setCustomerEmail
} from './finalCheckActions';
import {
  canShowMyRoomTab,
  canShowTemplatesTab,
  setInstagramLoginFlag,
  templatesTabItemIsSelected
} from './sideBarActions';
// import { laptopStore } from '../components/LaptopStore';
// import { posterStore } from '../components/PosterStore';
import { Theme, ChildTheme } from './ProjectData/Theme';
import { WallLayout } from './ProjectData/WallLayout';
import { Scene, Element, UserPhoto, Text } from './ProjectData/Placebale';
import { Project, copyProject } from './ProjectData/Project';
import { Store, updateStoreWithSupportedProducts } from './ProjectData/Store';
import { setCurrentPageIndex } from './pageControllerActions';
import { multiWallSupport, setSharedSceneTo } from './actions/multiWallHandler';
import { sizeSettingsAreChanged } from './actions/sizeHandler';

const promises = [];

export const initiateSession = () => dispatch => {
  // api.setResourcePrefix('http://designer.localhost:3000'); // Uncomment this line for development
  // api.setResourcePrefix('https://designer.integration.hpwallart.com'); // Uncomment this line for development
  api
    .setSession()
    .then(res => {
      if (res.data.result === 'SUCEEDED') {
        dispatch({
          type: actions.SET_SESSION,
          payload: { sessionData: res.data.data }
        });
        dispatch(getEnvVariables());
      }
    })
    .catch(() => {});
};

export const getEnvVariables = () => (dispatch, getState) => {
  const urlIdentifier = getState().modal.sessionData.url_identifier;
  const { gsku, sku } = getState().modal.sessionData;

  api
    .getEnvVariables(urlIdentifier, gsku, sku)
    .then(res => {
      const storeToken = res.data.store_token;

      if (res.data.store_id !== null && storeToken !== null) {
        dispatch({
          type: actions.FETCH_ENV_VARIABLES,
          payload: { res }
        });
        dispatch(getStoreDetails(storeToken));
      }
    })
    .catch(() => {});
};

export const getStoreDetails = storeToken => (dispatch, getState) => {
  const { gsku, sku } = getState().modal.sessionData;
  const urlIdentifier = getState().modal.sessionData.url_identifier;
  let shouldSkipProductsInRequest = false;
  if (gsku == 'LPTS') {
    shouldSkipProductsInRequest = true;
  }
  api
    .getStoreDetails(
      storeToken,
      gsku,
      sku,
      urlIdentifier,
      shouldSkipProductsInRequest
    )
    .then(store => {
      // store.data = laptopStore;
      const storeObject = new Store(store.data);
      if (shouldSkipProductsInRequest) {
        api
          .getProductDetailsInStore(
            storeObject.id,
            getState().modal.envData.group_cache_timestamp,
            storeObject.storeCacheTimestamp,
            storeObject.accountId
          )
          .then(storeProducts => {
            updateStoreWithSupportedProducts(storeObject, storeProducts.data);
            dispatch(continueSetStoreDetails(storeObject));
          })
          .catch(() => {});
      } else {
        dispatch(continueSetStoreDetails(storeObject));
      }
    })
    .catch(() => {});
};

export const initializeProductSizes = storeData => (dispatch, getState) => {
  const {
    allowCustomSizeInPreset,
    productIconUrl,
    designerLandscapeIconUrl,
    designerPortraitIconUrl,
    presetSizes,
    fixedSizes,
    variableSizeType,
    minCustomWidthImperial,
    maxCustomWidthImperial,
    minCustomWidthMetric,
    maxCustomWidthMetric,
    minCustomHeightImperial,
    maxCustomHeightImperial,
    minCustomHeightMetric,
    maxCustomHeightMetric,
    designerCustomSizeIcon
  } = storeData;

  const productStack = {
    default: {
      iconUrl: {
        productIconUrl,
        designerLandscapeIconUrl,
        designerPortraitIconUrl
      },
      sizes: []
    },
    custom: {
      iconUrl: designerCustomSizeIcon
    }
  };

  // If variable_size_type is Preset Then Preset option is there and Show/Hide Custom option is based on allow_custom_size_in_preset
  // If variable_size_type is custom Then only Custom option is there.
  let sizesArray = [];
  if (dispatch(isPresetSizeAvailableInLaunch(variableSizeType))) {
    if (getState().modal.envData.is_lite_patner) {
      sizesArray = fixedSizes;
    } else {
      sizesArray = presetSizes;
    }
  }
  sizesArray.forEach(item => {
    productStack.default.sizes.push(item);
  });
  if (
    isCustomSizeAvailableInProjectLaunch(
      variableSizeType,
      allowCustomSizeInPreset
    )
  ) {
    productStack.custom.sizes = {
      Imperial: {
        minCustomWidth: minCustomWidthImperial,
        maxCustomWidth: maxCustomWidthImperial,
        minCustomHeight: minCustomHeightImperial,
        maxCustomHeight: maxCustomHeightImperial
      },
      Metric: {
        minCustomWidth: minCustomWidthMetric,
        maxCustomWidth: maxCustomWidthMetric,
        minCustomHeight: minCustomHeightMetric,
        maxCustomHeight: maxCustomHeightMetric
      }
    };
  }
  dispatch({
    type: actions.SET_AVAILABLE_PROJECT_SIZES,
    payload: { productStack }
  });
};

export const continueSetStoreDetails = storeData => (dispatch, getState) => {
  dispatch(initializeProductSizes(storeData));
  dispatch({
    type: actions.FETCH_STORE_DETAILS,
    payload: { storeData }
  });
  if (
    getState().modal.envData.category != null &&
    getState().modal.envData.category != ''
  ) {
    dispatch(setSingleProduct(true));
  }
  dispatch(storeDetailsAreFetched());
};

export const storeDetailsAreFetched = () => (dispatch, getState) => {
  const { storeData } = getState().modal;
  api.setStoreContentToken(storeData.contentToken);
  const project = new Project();
  dispatch({
    type: actions.SET_PROJECT_STRUCTURE,
    payload: { project }
  });
  dispatch(checkForProjectEdit());
};

export const updateSizeValuesInStoreFromProjectData = () => (
  dispatch,
  getState
) => {
  const { project } = getState().finalCheck;
  const { canvasRowsCount, canvasColumnsCount, width, height } = project;

  if (isCanvasApp(project.category)) {
    // set canvas type(single or multicanvas) depending on either of  row>1 and column >1
    if (canvasRowsCount > 1 || canvasColumnsCount > 1) {
      dispatch(setCanvasType(Constants.MULTI_CANVAS));
      dispatch({
        type: actions.SET_ROW,
        payload: { value: canvasRowsCount, rowInput: canvasRowsCount }
      });
      dispatch({
        type: actions.SET_COLUMN,
        payload: { value: canvasColumnsCount, columnInput: canvasColumnsCount }
      });
    }

    dispatch({
      type: actions.SET_CANVAS_WALL_WIDTH,
      payload: {
        canvasWallWidth: project.activeWall.width,
        widthInput: project.activeWall.width
      }
    });
    dispatch({
      type: actions.SET_CANVAS_WALL_HEIGHT,
      payload: {
        canvasWallHeight: project.activeWall.height,
        heightInput: project.activeWall.height
      }
    });
  }
  if (project.activeWall) {
    dispatch(
      sizeSettingsAreChanged(
        width,
        height,
        canvasRowsCount,
        canvasColumnsCount,
        project.activeWall.width,
        project.activeWall.height
      )
    );
  }
};

export const continueAfterProjectEdit = () => dispatch => {
  dispatch(updateSizeValuesInStoreFromProjectData());
  dispatch(setExternalLink());
  dispatch(setExternalContent());
  dispatch(setWebLink());
  dispatch(setApplicationGroupId());

  // For Edit link product gets set here.
  if (isSignageSuiteProduct()) {
    dispatch(checkForSingleProduct());
  }
  dispatch(getStartupTheme());
};

export const startUpContentsAreFetched = () => (dispatch, getState) => {
  const { storeData } = getState().modal;
  dispatch(getFontDetails(storeData.id, storeData.cacheTimestamp));
  dispatch(getDefaultColors(storeData.id, storeData.cacheTimestamp));
};

export const allContentsAreFetched = () => dispatch => {
  dispatch(setNoContentResourcePrefix());
  if (dispatch(canShowMyRoomTab())) {
    dispatch(fetchWallLayouts());
  }
  if (dispatch(canShowTemplatesTab())) {
    dispatch(getInspirationCategories());
  }
};

export const fetchWallLayouts = () => (dispatch, getState) => {
  const { cacheTimestamp } = getState().modal.storeData;
  api.getWallLayouts(cacheTimestamp).then(response => {
    const wallLayoutObjectArray = createResponseObject(
      response.data,
      Constants.WALL_LAYOUT_KEY
    );
    dispatch({
      type: actions.FETCH_WALL_LAYOUTS,
      payload: { wallLayouts: wallLayoutObjectArray }
    });
  });
};

export const setDefaultValues = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  const { storeData } = getState().modal;

  let defaultUnit = storeData.lengthUnitSystem;
  if (project.id && project.unitSystem) {
    defaultUnit = project.unitSystem;
  }
  dispatch({
    type: actions.UNIT_SYSTEM_CHANGED,
    payload: { unitSystem: defaultUnit }
  });

  project.placeMsrpCurrency = storeData.placeMsrpCurrency;
  if (!project.canvasFrameType) {
    project.canvasFrameType = storeData.canvasFrameType;
  }
  if (!project.canvasFrameColor) {
    project.canvasFrameColor = storeData.canvasFrameColor;
  }

  let defaultLanguage = CookieUtils.getLanguageKey(storeData.id);
  if (!defaultLanguage) {
    defaultLanguage = storeData.defaultLanguage;
  }
  if (project.id && project.language) {
    defaultLanguage = project.language;
  }
  if (getState().modal.envData.selected_language) {
    defaultLanguage = getState().modal.envData.selected_language;
  }
  dispatch(changeLanguage({ value: defaultLanguage }));

  let { customerName } = project;
  if (!customerName) {
    customerName = getState().modal.envData.customer_name;
  }
  dispatch(setCustomerName(customerName));

  let { customerEmail } = project;
  if (!customerEmail) {
    customerEmail = getState().modal.envData.customer_email;
  }
  dispatch(setCustomerEmail(customerEmail));

  dispatch(setAccountId());

  const isInstagramLoggedIn = getState().modal.envData.instagram_user_logged_in;
  dispatch(setInstagramLoginFlag(isInstagramLoggedIn));

  const { targetViewingDistance } = project;
  if (!targetViewingDistance) {
    const { defaultViewingDistance } = storeData;
    dispatch(changeMinimumViewingDistance(defaultViewingDistance));
  }

  let defaultColor = '#000000';
  if (getState().modal.defaultColors.length > 1) {
    [defaultColor] = getState().modal.defaultColors;
  }
  dispatch({
    type: actions.SET_TEXT_COLOR,
    payload: { value: defaultColor }
  });
  if (orientationSupportedProducts(getState().modal.envData.category)) {
    dispatch({
      type: actions.ORIENTATION_CHANGED,
      payload: { orientation: Constants.PORTRAIT_KEY }
    });
  }
};

export const isProductListed = category => (dispatch, getState) => {
  const { supportedProducts } = getState().modal.storeData;
  for (let i = 0; i < supportedProducts.length; i++) {
    if (supportedProducts[i].category === category) {
      return true;
    }
  }
  return false;
};

export const checkForProjectEdit = () => (dispatch, getState) => {
  const queryDict = getURLQueryStringAsDictionary();
  let projectToken = null;
  let projectId = null;

  if (queryDict.clonable_project_token) {
    projectToken = queryDict.clonable_project_token;
  }

  if (queryDict.project_token) {
    projectToken = queryDict.project_token;
  }
  if (queryDict.project_id) {
    projectId = queryDict.project_id;
  }

  const projectTokenFromCookies = CookieUtils.resumeActivityCookieProjectId();
  const projectCategoryFromCookie = CookieUtils.resumeActivityCookieProjectCategory();
  const projectGskuFromCookie = CookieUtils.resumeActivityCookieGsku();
  const { gsku } = getState().modal.sessionData;

  // In case user close the browser after login, cookie will not get deleted. Hence check for category when he launches again.
  // If it same then only load the project.
  if (
    projectTokenFromCookies &&
    projectGskuFromCookie === gsku &&
    dispatch(isProductListed(projectCategoryFromCookie))
  ) {
    projectToken = projectTokenFromCookies;
  }

  if (projectId) {
    // weblink editlet resourcePrefix = null;
    const storeId = getState().modal.storeData.id;

    api
      .fetchProjectDetailsFromExternalId(projectId, storeId)
      .then(responseData => {
        if (responseData[0] >= 400) {
          return;
        }
        const projectJSON = responseData.data;
        getState().modal.envData.view_only_preview_mode = queryDict.view
          ? queryDict.view
          : false;
        dispatch(projectDetailsAreFetched(projectJSON));
      })
      .catch(() => {});
  } else if (projectToken) {
    api
      .fetchProjectDetails(projectToken)
      .then(responseData => {
        const projectJSON = responseData.data;
        getState().modal.envData.view_only_preview_mode =
          projectJSON.view_token === projectToken;
        dispatch(projectDetailsAreFetched(projectJSON));
        // if (queryDict['clonableProjectToken']) {
        //   prepareInspirationForSave(getState, projectJSON);
        // }
      })
      .catch(() => {});
  } else {
    dispatch(continueAfterProjectEdit());
  }
};

export const checkForSingleProduct = () => (dispatch, getState) => {
  const product = dispatch(getProductWithName());
  const { project } = getState().finalCheck;
  const { activeWall } = project;

  if (product) {
    dispatch(setSelectedProduct(product));
    dispatch(setSingleProduct(true));
    if (activeWall) {
      dispatch(setCurrentPageIndex(Constants.DESIGN_PAGE));
      dispatch(
        updateModelsForSelectedWallSize(activeWall.width, activeWall.height)
      );
      dispatch(selectWall(activeWall.width, activeWall.height));
    }
  }
};

export const fetchMultiWallProjects = activeProject => (dispatch, getState) => {
  const { storeData } = getState().modal;
  const projectGroupPromiseObj = new Promise(resolve => {
    api
      .fetchProjects(
        activeProject.projectGroupId,
        activeProject.storeId,
        storeData.cacheTimestamp
      )
      .then(response => {
        const projectsList = [];
        response.data.forEach(responseData => {
          const projectData = new Project();
          copyProject(projectData, responseData);
          projectData.isMultiWall = true;
          projectsList.push(projectData);
        });
        dispatch({
          type: actions.SET_MULTIWALL_PROJECTS,
          payload: {
            multiWallProjects: projectsList
          }
        });
        const activeIndex = projectsList.findIndex(
          inProject => inProject.id == activeProject.id
        );
        if (activeIndex != -1) {
          dispatch({
            type: actions.SET_ACTIVE_MULTIWALL_PROJECT_INDEX,
            payload: { activeMultiWallProjectIndex: activeIndex }
          });
          dispatch({
            type: actions.SET_PROJECT_STRUCTURE,
            payload: { project: projectsList[activeIndex] }
          });
          dispatch({
            type: actions.SET_SHARED_SCENE_DATA,
            payload: {
              sharedSceneData: {
                placing: projectsList[activeIndex].scenePlacings[0],
                projectIndex: activeIndex
              }
            }
          });
          resolve();
        }
      });
  });
  return projectGroupPromiseObj;
};

const projectDetailsAreFetched = projectJSON => (dispatch, getState) => {
  dispatch(setSingleProduct(true));

  const { storeData } = getState().modal;

  const cookie = CookieUtils.resumeActivityCookieActivity();
  if (
    (cookie == Constants.LITE_SAVE_ACTIVITY ||
      cookie == Constants.LITE_CHECKOUT_ACTIVITY) &&
    getState().modal.envData.is_lite_patner
  ) {
    projectJSON.store_id = storeData.id;
    projectJSON.target_viewing_distance = storeData.target_viewing_distance;
  }
  const project = new Project();
  copyProject(project, projectJSON);
  project.storeId = storeData.id;

  if (dispatch(multiWallSupport())) {
    dispatch(fetchMultiWallProjects(project)).then(() => {
      dispatch(setSharedSceneTo(project, project.sharedScene));
      dispatch(continueAfterProjectEdit());
    });
  } else {
    dispatch({
      type: actions.SET_PROJECT_STRUCTURE,
      payload: { project }
    });
    dispatch(continueAfterProjectEdit());
  }
};

export const getFontDetails = (storeId, cacheTimestamp) => dispatch => {
  api
    .getFontDetails(storeId, cacheTimestamp)
    .then(res => {
      const textFonts = res.data;
      dispatch({
        type: actions.FETCH_FONTS,
        payload: { textFonts }
      });
      const defaultFontList = textFonts.filter(
        f => f.font_family === Constants.DEFAULT_FONT
      );
      let defaultFont;
      if (defaultFontList.length > 0) {
        [defaultFont] = defaultFontList;
      } else {
        [defaultFont] = textFonts;
      }
      dispatch({
        type: actions.SET_FONT_FAMILY,
        payload: { value: defaultFont.id }
      });
      loadFonts(textFonts, () => {});
    })
    .catch(() => {});
};

export const loadFonts = (textFonts, callback) => {
  let counter = 0;
  if (textFonts.length > 0) {
    textFonts.forEach(font => {
      const fontObj = new FontFace(
        font.font_family,
        `url(${font.font_file_url})`
      );
      fontObj.load().then(loadedFont => {
        document.fonts.add(loadedFont);
        counter++;
        if (counter === textFonts.length) {
          callback();
        }
      });
    });
  } else {
    callback();
  }
};

export const retailerDetailsAreFetched = () => dispatch => {
  dispatch(setDefaultValues());
  dispatch(fetchWallArtAndExternalContents());
};

export const checkForRetailerPoscode = () => (dispatch, getState) => {
  const posCode = retailerPosCode();
  const employeeCode = retailerEmployeeCode();
  if (posCode) {
    api
      .validateRetailerPosCode(posCode, getState().modal.storeData.id)
      .then(responseData => {
        if (responseData.data.result === 'SUCCESS') {
          getState().modal.envData.account_id = responseData.data.account_id;
          getState().modal.envData.customer_name =
            responseData.data.contact_name;
          getState().modal.envData.customer_email =
            responseData.data.contact_email;
          getState().modal.envData.account_info =
            responseData.data.account_info;
          getState().finalCheck.project.posCode = posCode;
          getState().finalCheck.project.employeeCode = employeeCode;
        }
        dispatch(retailerDetailsAreFetched());
      })
      .catch(() => {
        dispatch(retailerDetailsAreFetched());
      });
  } else {
    dispatch(retailerDetailsAreFetched());
  }
};

export const getDefaultColors = (storeId, cacheTimestamp) => dispatch => {
  api
    .getDefaultColors(storeId, cacheTimestamp)
    .then(res => {
      const defaultColors = res.data;
      const textColors = [];
      defaultColors.forEach(color => {
        const colorStringWithHash = `#${color.rgb}`;
        textColors.push(colorStringWithHash);
      });

      const remCount = Colors.HARDCODED_COLORS.length - defaultColors.length;
      for (let i = 0; i < remCount; i++) {
        textColors.push(Colors.HARDCODED_COLORS[i]);
      }
      dispatch({
        type: actions.FETCH_DEFAULT_COLORS,
        payload: { defaultColors: textColors }
      });
      dispatch(checkForRetailerPoscode());
    })
    .catch(() => {});
};

export const getStartupTheme = () => async dispatch => {
  let themeId;
  let themeName;
  api
    .getStartupThemeDetails()
    .then(res => {
      themeId = res.data.id;
      themeName = res.data.name;
      api
        .getStartupSceneDetails(res.data.id)
        .then(response => {
          const sceneData = createResponseObject(
            response.data,
            Constants.SCENE_KEY
          )[0];
          sceneData.externalPlaceable = false;
          sceneData.themeId = themeId;
          sceneData.themeName = themeName;
          dispatch({
            type: actions.GET_STARTUP_SCENE,
            payload: { startUpScene: sceneData }
          });
          dispatch(startUpContentsAreFetched());
        })
        .catch(() => {});
    })
    .catch(() => {});
};

export const getInspirationCategories = () => dispatch => {
  api
    .getInspirationFilters()
    .then(res => {
      if (res.status === 200) {
        dispatch({
          type: actions.SET_INSPIRATION_CATEGORY,
          payload: { inspirationCategory: res.data }
        });
        dispatch(templatesTabItemIsSelected(Constants.inspirationsTab));
      }
    })
    .catch(() => {});
};

export const shouldAddExternalContents = (
  useOwnContent,
  contentHostingSite,
  externalContentSite,
  wallartLiteExternalContent,
  wallartLiteWebLink
) => {
  const isEditProject = canEditProject();
  const wallartLiteWebLinkEdit = isWallartLiteWebLinkEdit();
  let themeResourcePrefix = contentHostingSite;
  if (wallartLiteExternalContent) {
    themeResourcePrefix = externalContentSite;
  }

  let canAddExternalContents =
    (wallartLiteWebLink && useOwnContent && !isEditProject) ||
    (wallartLiteWebLinkEdit && useOwnContent) ||
    (wallartLiteWebLink && isEditProject && useOwnContent);

  canAddExternalContents = canAddExternalContents || wallartLiteExternalContent;
  return themeResourcePrefix && canAddExternalContents;
};

const shouldIncludeWallArtContents = (envData, storeData) => {
  let canIncludeWallArtContents = false;
  const projectIncludeWallartContent = storeData.includeWallartContent;
  const wallartLiteWebLink = envData.wallart_lite_web_link;
  const isEditProject = canEditProject();
  const wallartLiteWebLinkEdit = isWallartLiteWebLinkEdit();
  const wallartLiteExternalContent = envData.wallart_lite_external_content;

  //  let queryDict = getURLQueryStringAsDictionary();

  // if (queryDict['project_token']) {
  //   wallartLiteWebLinkEdit = true;
  // } else {
  //   wallartLiteWebLinkEdit = false;
  // }

  // if (queryDict['project_id']) {
  //   isEditProject = true;
  // } else {
  //   isEditProject = false;
  // }

  if (
    (wallartLiteWebLink && projectIncludeWallartContent && !isEditProject) ||
    (wallartLiteWebLinkEdit && projectIncludeWallartContent) ||
    (wallartLiteWebLink && isEditProject && projectIncludeWallartContent) ||
    (storeData.id !== '' &&
      !wallartLiteExternalContent &&
      !wallartLiteWebLink &&
      !wallartLiteWebLinkEdit)
  ) {
    canIncludeWallArtContents = true;
  }
  return canIncludeWallArtContents;
};

export const fetchWallArtAndExternalContents = () => async (
  dispatch,
  getState
) => {
  const { storeData, envData } = getState().modal;
  const themesArray = {
    scenesData: [],
    elementsData: [],
    photosData: []
  };
  const themeResponseList = [];

  const { useOwnContent, contentHostingSite, externalContentSite } = storeData;
  const wallartLiteExternalContent = envData.wallart_lite_external_content;
  const wallartLiteWebLink = envData.wallart_lite_web_link;
  if (
    shouldAddExternalContents(
      useOwnContent,
      contentHostingSite,
      externalContentSite,
      wallartLiteExternalContent,
      wallartLiteWebLink
    )
  ) {
    dispatch(
      fetchExternalContents(
        themesArray,
        themeResponseList,
        inThemeResponseList => {
          if (shouldIncludeWallArtContents(envData, storeData)) {
            dispatch(fetchWallartContents(themesArray, inThemeResponseList));
          } else {
            dispatch(themeFetchingIsDone(themesArray, inThemeResponseList));
          }
        }
      )
    );
  } else {
    dispatch(fetchWallartContents(themesArray, themeResponseList));
  }
};

export const setExternalContentResourcePrefix = () => (dispatch, getState) => {
  const { storeData, envData } = getState().modal;
  let resourcePrefix = storeData.contentHostingSite;
  if (envData.wallart_lite_external_content) {
    resourcePrefix = storeData.externalContentSite;
    // resourcePrefix = 'https://integration.individuwall.me/content';
    // api.setResourcePrefix('https://designer.integration.hpwallart.com/content'); // Uncomment this line for development
  }
  api.setResourcePrefix(resourcePrefix);
};

export const setInternalContentResourcePrefix = () => () => {
  api.setResourcePrefix('/content');
  // api.setResourcePrefix(
  //   'https://designer.integration.hpwallart.com/content'
  // );
  // api.setResourcePrefix('http://designer.localhost:3000');
};

export const setNoContentResourcePrefix = () => () => {
  api.setResourcePrefix('');
  // api.setResourcePrefix('https://designer.integration.hpwallart.com');
  // api.setResourcePrefix('http://designer.localhost:3000');
};

const fetchExternalContents = (
  themesArray,
  themeResponseList,
  callback
) => async (dispatch, getState) => {
  const { envData, storeData } = getState().modal;

  dispatch(setExternalContentResourcePrefix());
  const paramsDict = {};
  if (envData.account_id) {
    paramsDict.account_id = envData.account_id;
  }
  if (envData.content_context_token) {
    paramsDict.content_context_token = envData.content_context_token;
  }
  dispatch(
    getThemesArray(
      themesArray,
      themeResponseList,
      true,
      paramsDict,
      storeData,
      envData,
      callback
    )
  );
};

const fetchWallartContents = (themesArray, themeResponseList) => async (
  dispatch,
  getState
) => {
  const { envData, storeData } = getState().modal;

  dispatch(setInternalContentResourcePrefix());

  const paramsDict = {};
  if (envData.account_id) {
    paramsDict.account_id = envData.account_id;
  }
  paramsDict.store_id = storeData.id;
  dispatch(
    getThemesArray(
      themesArray,
      themeResponseList,
      false,
      paramsDict,
      storeData,
      envData,
      null
    )
  );
};

export const createResponseObject = (response, type, userPhotoType) => {
  const contentArray = [];
  _.forEach(response, resData => {
    let contentObject;
    switch (type) {
      case Constants.THEME_KEY:
        contentObject = new Theme(resData);
        break;
      case Constants.CHILD_THEME_KEY:
        contentObject = new ChildTheme(resData);
        break;
      case Constants.SCENE_KEY:
        contentObject = new Scene(resData);
        break;
      case Constants.ELEMENT_KEY:
      case Constants.PHOTO_KEY:
        contentObject = new Element(resData);
        break;
      case Constants.USER_PHOTO_TYPE:
        resData.image_source = userPhotoType;
        contentObject = new UserPhoto(resData);
        break;
      case Constants.TEXT_ELEMENT_TYPE:
        contentObject = new Text(resData);
        break;
      case Constants.WALL_LAYOUT_KEY:
        contentObject = new WallLayout(resData);
        break;
      default:
        break;
    }
    contentArray.push(contentObject);
  });
  return contentArray;
};

export const getThemesArray = (
  themesArray,
  inThemeResponseList,
  isExternalContent,
  paramsDict,
  storeData,
  envData,
  callback
) => async (dispatch, getState) => {
  const { cacheTimestamp } = storeData;
  const { category } = getState().modal.envData;
  let themeResponseList = inThemeResponseList;
  api
    .fetchThemes(paramsDict, cacheTimestamp, storeData.id)
    .then(res => {
      const currentResponseList = createResponseObject(
        res.data,
        Constants.THEME_KEY
      );
      themeResponseList = themeResponseList.concat(currentResponseList);
      currentResponseList.forEach(theme => {
        generateSceneThemeArray(
          theme,
          category,
          storeData,
          envData,
          Constants.SCENE_KEY,
          themesArray.scenesData,
          isExternalContent,
          cacheTimestamp
        );
        generateElementThemeArray(
          theme,
          category,
          storeData,
          envData,
          Constants.ELEMENT_KEY,
          themesArray.elementsData,
          isExternalContent,
          cacheTimestamp
        );
        if (!isExternalContent) {
          generatePhotoThemeArray(
            theme,
            category,
            storeData,
            envData,
            Constants.PHOTO_KEY,
            themesArray.photosData,
            isExternalContent,
            cacheTimestamp
          );
        }
      });
      Promise.all(promises).then(() => {
        if (callback) {
          callback(themeResponseList);
        } else {
          dispatch(themeFetchingIsDone(themesArray, themeResponseList));
        }
      });
    })
    .catch(() => {});
};

const themeFetchingIsDone = (themesArray, themeResponseList) => dispatch => {
  dispatch({
    type: actions.GET_THEMES_ARRAY,
    payload: { themesArray }
  });
  dispatch({
    type: actions.SET_THEME_RESPONSE,
    payload: { themeResponseList }
  });

  dispatch(generateThemeFolders(themeResponseList));
  dispatch(allContentsAreFetched());
};

export const reOrderThemes = inData => {
  let hostedContentArrangeIndex = 0;
  const themesData = inData;
  const hostedThemes = themesData.filter(theme => isHostedContent(theme));
  let themeRearranegIndex = hostedThemes.length;

  inData.forEach((theme, index) => {
    if (isHostedContent(theme)) {
      inData.splice(hostedContentArrangeIndex++, 0, inData.splice(index, 1)[0]);
    }

    if (isPremiumTheme(theme)) {
      inData.splice(themeRearranegIndex++, 0, inData.splice(index, 1)[0]);
    }
  });
  return inData;
};

async function generateSceneThemeArray(
  parentTheme,
  category,
  storeData,
  envData,
  type,
  data,
  isExternalContent,
  timestamp
) {
  promises.push(
    requestForThemeScenes(
      parentTheme,
      category,
      storeData,
      envData,
      type,
      data,
      isExternalContent,
      timestamp
    )
  );
  if (parentTheme.themes.length > 0) {
    parentTheme.themes.forEach(async theme => {
      if (theme.themes.length > 0) {
        generateSceneThemeArray(
          theme,
          category,
          storeData,
          envData,
          type,
          data,
          isExternalContent,
          timestamp
        );
      } else {
        promises.push(
          requestForThemeScenes(
            theme,
            category,
            storeData,
            envData,
            type,
            data,
            isExternalContent,
            timestamp
          )
        );
      }
    });
  }
  Promise.resolve();
}

async function requestForThemeScenes(
  theme,
  category,
  storeData,
  envData,
  type,
  data,
  isExternalContent,
  timestamp
) {
  if (
    isExternalContent ||
    shouldSendThemeRequest(theme, type, storeData, envData, category)
  ) {
    const paramsDict = {};
    if (envData.content_context_token) {
      paramsDict.content_context_token = envData.content_context_token;
    }
    await api
      .getThemeElements(theme.id, type, storeData.id, paramsDict, timestamp)
      .then(res => {
        const sceneObjects = createResponseObject(res.data, type);
        sceneObjects.forEach(sceneObject => {
          sceneObject.externalPlaceable = isExternalContent;
          sceneObject.themeId = theme.id;
          sceneObject.themeName = theme.name;
        });

        const {
          id,
          name,
          locNames,
          parentId,
          hostedContentThemeId,
          themes,
          thumbnailPath,
          internalName,
          needsAuthenetication,
          exclusiveProductIds,
          sceneIds
        } = theme;

        data.push({
          id,
          name,
          locNames,
          parentId,
          hostedContentThemeId,
          themes,
          thumbnailPath,
          internalName,
          isExternalContent,
          elements: sceneObjects,
          needsAuthenetication,
          exclusiveProductIds,
          sceneIds
        });
      });
  }
}

async function generateElementThemeArray(
  parentTheme,
  category,
  storeData,
  envData,
  type,
  data,
  isExternalContent,
  timestamp
) {
  promises.push(
    requestForThemeElements(
      parentTheme,
      category,
      storeData,
      envData,
      type,
      data,
      isExternalContent,
      timestamp
    )
  );
  if (parentTheme.themes.length > 0) {
    parentTheme.themes.forEach(async theme => {
      if (theme.themes.length > 0) {
        generateElementThemeArray(
          theme,
          category,
          storeData,
          envData,
          type,
          data,
          isExternalContent,
          timestamp
        );
      } else {
        promises.push(
          requestForThemeElements(
            theme,
            category,
            storeData,
            envData,
            type,
            data,
            isExternalContent,
            timestamp
          )
        );
      }
    });
  }
  return Promise.resolve();
}

async function generatePhotoThemeArray(
  parentTheme,
  category,
  storeData,
  envData,
  type,
  data,
  isExternalContent,
  timestamp
) {
  promises.push(
    requestForThemeElements(
      parentTheme,
      category,
      storeData,
      envData,
      type,
      data,
      isExternalContent,
      timestamp
    )
  );
  if (parentTheme.themes.length > 0) {
    parentTheme.themes.forEach(async theme => {
      if (theme.themes.length > 0) {
        generatePhotoThemeArray(
          theme,
          category,
          storeData,
          envData,
          type,
          data,
          isExternalContent,
          timestamp
        );
      } else {
        promises.push(
          requestForThemeElements(
            theme,
            category,
            storeData,
            envData,
            type,
            data,
            isExternalContent,
            timestamp
          )
        );
      }
    });
  }
  return Promise.resolve();
}

async function requestForThemeElements(
  theme,
  category,
  storeData,
  envData,
  type,
  data,
  isExternalContent,
  timestamp
) {
  if (
    isExternalContent ||
    shouldSendThemeRequest(theme, type, storeData, envData, category)
  ) {
    const paramsDict = {};
    if (envData.content_context_token) {
      paramsDict.content_context_token = envData.content_context_token;
    }

    await api
      .getThemeElements(
        theme.id,
        Constants.ELEMENT_KEY,
        storeData.id,
        paramsDict,
        timestamp
      )
      .then(res => {
        let filterArray = [];

        if (type === Constants.PHOTO_KEY) {
          filterArray = res.data.filter(item => item.is_photo);
        } else if (type === Constants.ELEMENT_KEY) {
          filterArray = res.data.filter(item => !item.is_photo);
        }
        const elementObjects = createResponseObject(filterArray, type);
        elementObjects.forEach(elementObject => {
          elementObject.externalPlaceable = isExternalContent;
          elementObject.themeId = theme.id;
          elementObject.themeName = theme.name;
        });

        const {
          id,
          name,
          locNames,
          parentId,
          hostedContentThemeId,
          themes,
          thumbnailPath,
          internalName,
          needsAuthenetication,
          exclusiveProductIds,
          elementIds,
          photoIds
        } = theme;

        const requitedThemeProps = {
          id,
          name,
          locNames,
          parentId,
          hostedContentThemeId,
          themes,
          thumbnailPath,
          internalName,
          isExternalContent,
          elements: elementObjects,
          needsAuthenetication,
          exclusiveProductIds
        };

        if (type === Constants.PHOTO_KEY) {
          requitedThemeProps.photoIds = photoIds;
        } else if (type === Constants.ELEMENT_KEY) {
          requitedThemeProps.elementIds = elementIds;
        }
        data.push(requitedThemeProps);
      });
  }
}

export const generateProductSpecificThemeFolders = themeList => async (
  dispatch,
  getState
) => {
  const { themesArray } = getState().modal;
  if (!themeList || !themesArray) {
    return;
  }

  const tempScenesData = [];
  const tempElementsData = [];
  const tempPhotosData = [];

  dispatch(
    getOneLevelFolders(
      themeList,
      tempScenesData,
      themesArray.scenesData,
      Constants.SCENE_KEY
    )
  );
  dispatch(
    getOneLevelFolders(
      themeList,
      tempElementsData,
      themesArray.elementsData,
      Constants.ELEMENT_KEY
    )
  );
  dispatch(
    getOneLevelFolders(
      themeList,
      tempPhotosData,
      themesArray.photosData,
      Constants.PHOTO_KEY
    )
  );
  const scenesData = reOrderThemes(tempScenesData);
  const elementsData = reOrderThemes(tempElementsData);
  const photosData = reOrderThemes(tempPhotosData);

  dispatch({
    type: actions.UPDATE_THEME_ELEMENTS,
    payload: { scenesData, elementsData, photosData }
  });
};

export const generateThemeFolders = themeList => async (dispatch, getState) => {
  const { themesArray } = getState().modal;

  const tempScenesData = [];
  const tempElementsData = [];
  const tempPhotosData = [];

  dispatch(
    getOneLevelFolders(
      themeList,
      tempScenesData,
      themesArray.scenesData,
      Constants.SCENE_KEY
    )
  );
  dispatch(
    getOneLevelFolders(
      themeList,
      tempElementsData,
      themesArray.elementsData,
      Constants.ELEMENT_KEY
    )
  );
  dispatch(
    getOneLevelFolders(
      themeList,
      tempPhotosData,
      themesArray.photosData,
      Constants.PHOTO_KEY
    )
  );

  const scenesData = reOrderThemes(tempScenesData);
  const elementsData = reOrderThemes(tempElementsData);
  const photosData = reOrderThemes(tempPhotosData);

  dispatch({
    type: actions.FETCH_THEME_ELEMENTS,
    payload: { scenesData, elementsData, photosData }
  });
};

export function getOneLevelPatterns(categoryList, data, themesArray) {
  for (let i = 0; i < categoryList.length; i++) {
    const category = categoryList[i];
    const matchedThemes = themesArray.filter(
      t =>
        t.id === category.id &&
        (!Object.prototype.hasOwnProperty.call(t, 'isExternalContent') ||
          !t.isExternalContent)
    );
    if (matchedThemes.length > 0) {
      data.push(matchedThemes[0]);
    }
  }
}

export const getOneLevelFolders = (
  themeList,
  data,
  themesArray,
  contentType
) => dispatch => {
  for (let i = 0; i < themeList.length; i++) {
    const theme = themeList[i];

    // There is possibility of having same ids for internal and external content themes. Hence check for internal_name as well. Best solution is to check store ids. But current implementation has to be modified to achieve it,
    const validThemes = themesArray.filter(
      t => t.id === theme.id && t.internalName == theme.internalName
    );
    if (validThemes.length > 0) {
      const validTheme = validThemes[0];
      if (
        dispatch(productLevelValidation(validTheme, contentType)) &&
        dispatch(
          themeHasContents(validTheme, themeList, themesArray, contentType)
        )
      ) {
        data.push(validTheme);
      }
    }
  }
};

function numberOfContentsInTheme(theme, type) {
  let allScenesCount = 0;

  const themeScenesCount = theme[type] ? theme[type].length : 0;
  allScenesCount += themeScenesCount;
  let folderScenesCount = 0;
  const subThemes = theme.themes;
  if (subThemes.length > 0) {
    for (let i = 0; i < subThemes.length; i++) {
      folderScenesCount += numberOfContentsInTheme(subThemes[i], type);
    }
    allScenesCount += folderScenesCount;
  }
  return allScenesCount;
}

function themeHasContentsRecursively(theme, themeList, themesArray) {
  let allScenesCount = 0;
  const themeScenesCount = theme.elements.length;
  allScenesCount += themeScenesCount;

  let folderScenesCount = 0;
  const subThemes = theme.themes;
  if (subThemes.length > 0) {
    for (let i = 0; i < subThemes.length; i++) {
      const validThemes = themesArray.filter(t => t.id === subThemes[i].id);
      if (validThemes.length > 0) {
        const validTheme = validThemes[0];
        folderScenesCount += themeHasContentsRecursively(
          validTheme,
          themeList,
          themesArray
        );
      }
    }
    allScenesCount += folderScenesCount;
  }
  return allScenesCount;
}

export const themeHasContents = (
  theme,
  themeList,
  themesArray,
  contentType
) => (dispatch, getState) => {
  if (/_vecteezy/.test(theme.internalName)) {
    return false;
  }
  if (
    /_pattern_design/.test(theme.internalName) ||
    /_unsplash/.test(theme.internalName) ||
    /_hp_mosaic/.test(theme.internalName)
  ) {
    return true;
  }
  if (/_dreamstime/.test(theme.internalName)) {
    return (
      contentType !== Constants.ELEMENT_KEY &&
      getState().modal.envData.category !== Constants.GIFTWRAPS_CATEGORY
    );
  }
  if (/_adobe_stock/.test(theme.internalName)) {
    return (
      contentType !== Constants.ELEMENT_KEY &&
      getState().modal.envData.category !== Constants.GIFTWRAPS_CATEGORY &&
      !getState().modal.envData.is_vanilla_designer
    );
  }
  if (
    /_getty_images/.test(theme.internalName) ||
    /_istock/.test(theme.internalName)
  ) {
    return (
      !getState().modal.envData.production &&
      contentType !== Constants.ELEMENT_KEY
    );
  }
  if (
    theme.hostedContentThemeId &&
    dispatch(isHostedThemeSupportedForType(contentType))
  ) {
    const contentId = `${convertFromCamelCase(contentType)}Ids`;
    return theme[contentId].length > 0;
  }
  const allScenesCount = themeHasContentsRecursively(
    theme,
    themeList,
    themesArray
  );
  return allScenesCount > 0;
};

export const isHostedThemeSupportedForType = type => (dispatch, getState) => {
  if (type == Constants.SCENE_KEY) {
    return (
      getState().home.selectedProduct &&
      (isBannerApp(getState().home.selectedProduct.groupType) ||
        isRollupApp(getState().home.selectedProduct.groupType))
    );
  }
  return true;
};

export const supportsPatternDesign = (storeDetails, envData) => {
  if (envData.is_vanilla_designer) {
    return true;
  }
  let shouldShowPatternDesign = storeDetails.supportsPatternDesign;
  if (shouldShowPatternDesign) {
    if (envData.has_valid_pattern_design_account) {
      if (!storeDetails.allowSharingPatternDesignCredentials) {
        shouldShowPatternDesign = false;
      }
    }
  }
  return shouldShowPatternDesign;
};

export const supportsDreamstime = (storeDetails, envData) => {
  if (envData.is_vanilla_designer) {
    return true;
  }
  let shouldShowDreamstime = storeDetails.supportsDreamstime;
  if (shouldShowDreamstime) {
    if (envData.has_valid_dreamstime_account) {
      if (!storeDetails.allowSharingDreamstimeCredentials) {
        shouldShowDreamstime = false;
      }
    }
  }
  return shouldShowDreamstime;
};

function shouldSendThemeRequest(theme, type, storeDetails, envData, category) {
  const shouldSupportTheme = isSupportedTheme(
    theme,
    storeDetails.supportedThemeIds
  );
  if (!shouldSupportTheme) {
    return false;
  }

  if (/_pattern_design/.test(theme.internalName)) {
    if (type === Constants.SCENE_KEY) {
      return supportsPatternDesign(storeDetails, envData);
    }
    return false;
  }
  if (/_vecteezy/.test(theme.internalName)) {
    return false;
  }
  if (/_unsplash/.test(theme.internalName)) {
    if (type === Constants.PHOTO_KEY) {
      return storeDetails.supportsUnsplash;
    }
    return false;
  }
  if (/_dreamstime/.test(theme.internalName)) {
    if (
      type === Constants.SCENE_KEY ||
      type === Constants.PHOTO_KEY ||
      type === Constants.ELEMENT_KEY
    ) {
      return supportsDreamstime(storeDetails, envData);
    }
    return false;
  }
  if (/_getty_images/.test(theme.internalName)) {
    if (
      type === Constants.SCENE_KEY ||
      type === Constants.PHOTO_KEY ||
      type === Constants.ELEMENT_KEY
    ) {
      return (
        !envData.is_vanilla_designer &&
        !envData.production &&
        envData.has_valid_getty_images_account &&
        storeDetails.supportsGettyImages &&
        storeDetails.allowSharingGettyImagesCredentials
      );
    }
    return false;
  }
  if (/_istock/.test(theme.internalName)) {
    if (
      type === Constants.SCENE_KEY ||
      type === Constants.PHOTO_KEY ||
      type === Constants.ELEMENT_KEY
    ) {
      return (
        !envData.is_vanilla_designer &&
        !envData.production &&
        envData.has_valid_istock_account &&
        storeDetails.supportsIstock &&
        storeDetails.allowSharingIstockCredentials
      );
    }
    return false;
  }
  if (/hp_samples/.test(theme.internalName)) {
    if (type === Constants.SCENE_KEY || type === Constants.ELEMENT_KEY) {
      return (
        !envData.is_vanilla_designer &&
        category !== Constants.GIFTWRAPS_CATEGORY
      );
    }
    return false;
  }
  if (/_adobe_stock/.test(theme.internalName)) {
    if (type === Constants.SCENE_KEY || type === Constants.PHOTO_KEY) {
      return storeDetails.supportsAdobeStock && !envData.is_vanilla_designer;
    }
    return false;
  }
  if (/_hp_mosaic/.test(theme.internalName)) {
    if (
      type === Constants.SCENE_KEY &&
      category !== Constants.GIFTWRAPS_CATEGORY
    ) {
      return storeDetails.supportsHpMosaic;
    }
    return false;
  }
  if (/_patterns/.test(theme.internalName)) {
    if (type === Constants.SCENE_KEY && !envData.is_vanilla_designer) {
      return true;
    }
    return false;
  }
  const contentId = `${convertFromCamelCase(type)}Ids`;
  if (numberOfContentsInTheme(theme, contentId) > 0) {
    if (category === Constants.GIFTWRAPS_CATEGORY) {
      if (
        type === Constants.SCENE_KEY &&
        /default_giftwrap/.test(theme.internalName)
      ) {
        // if (category === Constants.GIFTWRAPS_CATEGORY) {
        //   return true;
        // }
        return true;
      }
      if (
        type === Constants.ELEMENT_KEY &&
        (/default_giftwrap_shapes/.test(theme.internalName) ||
          /default_giftwrap_stickers/.test(theme.internalName))
      ) {
        // if (category === Constants.GIFTWRAPS_CATEGORY) {
        //   return true;
        // }
        return true;
      }
      return false;

      // return category !== Constants.GIFTWRAPS_CATEGORY; //return true for all folders which are not giftwraps
    }
  }
  return true;
}

export const isSupportedTheme = (theme, supportedIds) =>
  supportedIds.indexOf(theme.id) > -1;

export const setDreamstimeUserLoggedIn = state => dispatch => {
  dispatch({
    type: actions.SET_DREAMSTIME_USER_LOGGED_IN,
    payload: { isLoggedIn: state }
  });
};

export const isApplicationSizeFromURL = () => (dispatch, getState) => {
  let isPDFConstraint = false;
  const groupId = getState().finalCheck.project.projectGroupId;
  const { envData } = getState().modal;
  const { category } = envData;
  if (isSignageSuiteProduct()) {
    if (!groupId && category) {
      const product = dispatch(getProductWithName());
      isPDFConstraint = product.constaintType === Constants.CONSTRAINT_TYPE_PDF;
    }
  }

  return (
    envData.product_width > 0 &&
    envData.product_height > 0 &&
    !groupId &&
    !isPDFConstraint &&
    (envData.wallart_lite_external_link || envData.wallart_lite_web_link)
  );
};

export const productLevelValidation = (theme, contentType) => (
  dispatch,
  getState
) => {
  let isValidatedInProductLevel = true;
  switch (contentType) {
    case Constants.SCENE_KEY:
      isValidatedInProductLevel = dispatch(isBackgroundSupported());
      break;
    case Constants.PHOTO_KEY:
      isValidatedInProductLevel = dispatch(isPhotoSupported());
      break;
    case Constants.ELEMENT_KEY:
      isValidatedInProductLevel = dispatch(isObjectSupported());
      break;
    default:
      break;
  }
  if (isValidatedInProductLevel) {
    if (theme.exclusiveProductIds && getState().home.selectedProduct) {
      return theme.exclusiveProductIds.find(
        id => id == getState().home.selectedProduct.productId
      );
    }
    // Omen laptop of turkey can have only one object
    if (dispatch(isOmenLaptopOfTurkeyAccount())) {
      if (contentType === Constants.ELEMENT_KEY) {
        return false;
      }
    }
  }
  return isValidatedInProductLevel;
};

export const isBackgroundSupported = () => dispatch => {
  if (dispatch(isOmenLaptop()) || dispatch(isOmenLaptopOfTurkeyAccount())) {
    return false;
  }
  return true;
};

export const isPhotoSupported = () => (dispatch, getState) => {
  if (
    getState().modal.envData.category === Constants.GIFTWRAPS_CATEGORY ||
    dispatch(isOmenLaptopOfTurkeyAccount())
  ) {
    return false;
  }
  return true;
};

export const isObjectSupported = () => () => true;

export const setSingleProduct = value => dispatch => {
  dispatch({
    type: actions.SET_SINGLE_PRODUCT,
    payload: { value }
  });
};
